import { Component } from 'opus-angular-seed-core';
import * as webeid from '../../../vendor/web-eid';

@Component({
    template: `
        <div class="col00">
            <div class="colholder multiline narrow-col equalize">
                <div class="col col00 fixed">
                    <div class="well color01">
                        <form role="form" ng-submit="vm.save()" ng-if="vm.authMethods.base">
                            <div ng-if="vm.$state.recoveryIsSent">
                               <alert-success>
                                  {{ 'auth.Password recovery link was sent to your e-mail address. Sending may take up to 5 minutes. Be sure to check your junk mail folder too.' | translate }}
                               </alert-success>
                            </div>
                            <h2>{{ 'auth.Log in with e-mail' | translate }}</h2>
                            <form-wrapper form="vm.form" success-message="{{ 'auth.Login successful' | translate }}">
                               <div class="form">
                                  <form-row error="vm.form.errors.email">
                                     <label class="label">{{ 'auth.E-mail' | translate }}</label>
                                     <div class="items">
                                        <input ng-model="vm.form.model.email" type="text" class="form-control">
                                        <form-row-error></form-row-error>
                                     </div>
                                  </form-row>
                                  <form-row error="vm.form.errors.password">
                                     <label class="label">{{ 'auth.Password' | translate }}</label>
                                     <div class="items">
                                        <input ng-model="vm.form.model.password" type="password" class="form-control" ng-model="vm.form.model.password">
                                        <form-row-error></form-row-error>
                                     </div>
                                  </form-row>
                               </div>
                            </form-wrapper>
                            <ul class="actions01 mobile-stretch">
                               <li class="f-right"><input type="submit" value="{{ 'auth.Log in' | translate }}" class="btn main"></li>
                               <li class="f-right"><a ng-click="vm.forgotPassword()" class="btn discrete">{{ 'auth.Forgot password?' | translate }}</a></li>
                            </ul>
                        </form>
                         <hr ng-if="vm.showAdditionalAuthMethods()"/>
                        <ul class="actions01 nomargin mobile-stretch" ng-if="vm.showAdditionalAuthMethods()">
                           <li ng-if="vm.authMethods.idCard">
                                <button ng-click="vm.idCardLogin()" class="btn btn-service idcard"></button>
                           </li>
                           <li ng-if="vm.authMethods.mobileId">
                                <a class="btn btn-service mobileid" ng-class="{selected: vm.login === 'mobileid'}" ng-click="vm.login='mobileid'">
                                    {{ 'auth.Mobile-ID' | translate }}
                                </a>
                            </li>
                           <li ng-if="vm.authMethods.smartId">
                                <a class="btn btn-service smartid" ng-class="{selected: vm.login === 'smartid'}" ng-click="vm.login='smartid'">
                                    {{ 'auth.Smart-ID' | translate }}
                                </a>
                            </li>
                           <li ng-if="vm.authMethods.sso">
                                <a class="btn btn-service azure" ng-click="vm.loginViaSaml();vm.login='samlLogin'">
                                    {{ 'auth.Azure SSO' | translate }}
                                </a>
                            </li>
                        </ul>
                        <div class="well-section" ng-if="vm.idCardError">
                            <alert-error>
                                {{ vm.idCardError }}
                            </alert-error>
                        </div>
                        <div class="well-section" ng-if="vm.samlError">
                            <alert-error ng-if="vm.samlError">
                                {{ vm.samlError }}
                            </alert-error>
                        </div>
                        <form ng-submit="vm.saveMobileId()">
                            <div class="well-section" ng-if="vm.login=='mobileid'">
                                <h2>{{ 'auth.Mobile-ID' | translate }}</h2>
                                <alert-error ng-if="vm.mobileIdError">
                                    {{ vm.mobileIdError }}
                                </alert-error>
                                <div class="form" ng-if="!vm.mobile || vm.mobileIdError">
                                    <div class="row">
                                        <label class="label">{{ 'auth.Mobile number' | translate }}</label>
                                        <div class="items">
                                            <input name="phone" type="text" ng-model="vm.phone" class="form-control">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label class="label">{{ 'auth.Personal code' | translate }}</label>
                                        <div class="items">
                                            <input name="phone" type="text" ng-model="vm.mobileIdPersonalCode" class="form-control">
                                        </div>
                                    </div>
                                    <ul class="actions01 mobile-stretch">
                                        <li class="f-right">
                                            <input
                                                type="submit"
                                                class="btn main"
                                                value="{{ 'auth.Log in' | translate }}"
                                            >
                                        </li>
                                    </ul>
                                </div>
                                <div ng-if="vm.mobile && !vm.mobileIdError && vm.mobileSecurityCode">
                                    <div class="alert alert-plain">{{ 'auth.Security code' | translate }} : {{ vm.mobileSecurityCode }}</div>
                                    <ul class="actions01 mobile-stretch">
                                        <li class="f-right">
                                            <a class="btn discrete" ng-click="vm.mobile=false">{{ 'auth.Cancel' | translate }}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </form>
                        <form>
                            <div class="well-section" ng-if="vm.login=='smartid'">
                                <h2>{{ 'auth.Smart-ID' | translate }}</h2>
                                <alert-error ng-if="vm.smartIdError">
                                    {{ vm.smartIdError }}
                                </alert-error>
                                <div class="form" ng-if="!vm.smartid || vm.smartIdError">
                                    <div class="row">
                                        <label class="label">{{ 'auth.Personal code' | translate }}</label>
                                        <div class="items">
                                            <input name="personalCode" type="text" ng-model="vm.personalCode" class="form-control">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label class="label">{{ 'auth.Country' | translate }}</label>
                                        <div class="items">
                                            <select ng-model="vm.countryCode" class="form-control">
                                                <option selected="selected" value="{{ 'EE' }}">{{ 'enums.Estonia' | translate }}</option>
                                                <option value="{{ 'LV' }}">{{ 'enums.Latvia' | translate }}</option>
                                                <option value="{{ 'LT' }}">{{ 'enums.Lithuania' | translate }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <ul class="actions01 mobile-stretch">
                                        <li class="f-right">
                                            <input class="btn main" type="button" ng-click="vm.isPersonalCodeEmpty() ? '' : vm.smartid = true" value="{{ 'auth.Log in' | translate }}">
                                        </li>
                                    </ul>
                                    </div>
                                    <div ng-if="vm.smartid && !vm.smartIdError">
                                        <div class="alert alert-plain">{{ 'auth.Security code' | translate }} : {{ vm.smartSecurityCode }}</div>
                                        <ul class="actions01 mobile-stretch">
                                            <li class="f-right"><a class="btn discrete" ng-click="vm.smartid=false">{{ 'auth.Cancel' | translate }}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($rootScope, $state, $window, $location, $translate, $interval, lodash, FormFactory, AuthResource, ModalService,
                 StateService, TokenService, AuthService, IdBouncerResource, toastr, Raven) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$location = $location;
        this.$window = $window;
        this.$translate = $translate;
        this.$interval = $interval;
        this.lodash = lodash;
        this.ModalService = ModalService;
        this.StateService = StateService;
        this.TokenService = TokenService;
        this.AuthService = AuthService;
        this.AuthResource = AuthResource;
        this.toastr = toastr;
        this.Raven = Raven;
        const defaultModel = {
            email: '',
            password: ''
        };
        this.form = FormFactory.create(
            defaultModel,
            model => AuthResource.authenticateWithEmail({ _lang: $rootScope.company.defaultLanguage.toLowerCase() }, model).$promise
        );
        $state.recoveryIsSent = false;
        this.IdBouncerResource = IdBouncerResource;
        this.countryCode = 'EE';
    }

    get authMethods () {
        return this.$rootScope.company.authMethods;
    }

    $onInit () {
        this.companySlug = this.$state.params.company;
        if (this.$location.search().accessToken !== undefined) {
            this.getUser(this.$location.search().accessToken);
        }
        this.handleSamlLogin();
    }

    handleSamlLogin () {
        this.samlError = null;
        const sessionId = localStorage.getItem('samlSessionId');
        if (sessionId && sessionId !== 'undefined') {
            localStorage.setItem('samlSessionId', undefined);
            this.AuthResource.samlProfile({
                sessionId
            }).$promise.then((response) => {
                this.AuthResource.loginSaml({
                    samlNameId: response.nameId,
                    sessionId,
                    companySlug: this.companySlug
                }).$promise.then(() => {
                    this.handleSuccess();
                }).catch(() => {
                    this.samlError = this.$translate.instant('auth.No such account was found or authentication was cancelled');
                });
            }).catch((error) => {
                this.samlError = this.lodash.get(error, 'data[0].message');
            });
        }
    }

    save () {
        // take slug from url (slug verification without user connection is already done if user is here)
        this.form.model.companySlug = this.companySlug;
        this.form
            .save().then(() => {
                const token = this.TokenService.token;
                if (token) {
                    this.AuthService.loginViaToken(token).then((user) => {
                        if (!user.isAccountActivated) {
                            this.ModalService.open({
                                template: '<modals-account-activate class="wrapper" close="vm.close()" company-terms="vm.terms"/>',
                                resolve: {
                                    company (CompanyResource) {
                                        return CompanyResource.terms().$promise;
                                    }
                                },
                                controller ($uibModalInstance, company) {
                                    this.terms = company.terms;
                                    this.$uibModalInstance = $uibModalInstance;
                                    this.close = () => {
                                        this.$uibModalInstance.close();
                                    };
                                }
                            });
                        }
                        else {
                            this.handleSuccess();
                        }
                    });
                }
                else {
                    this.handleSuccess();
                }
            });
    }

    forgotPassword () {
        return this.ModalService.open({
            template: '<modals-account-restore class="wrapper" cancel="vm.$uibModalInstance.dismiss()" update="vm.update()"/>',
            controller ($state, $uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    $state.recoveryIsSent = true;
                    this.$uibModalInstance.close();
                };
            }
        });
    }

    getUser (token) {
        return this.IdBouncerResource.idProfile({ accessToken: token, companySlug: this.companySlug }).$promise
            .then(() => {
                if (!this.TokenService.getUser().isAccountActivated) {
                    this.ModalService.open({
                        template: '<modals-account-activate class="wrapper" close="vm.close()"/>',
                        controller ($uibModalInstance) {
                            this.$uibModalInstance = $uibModalInstance;
                            this.close = () => this.$uibModalInstance.close();
                        }
                    });
                }
                else {
                    this.handleSuccess();
                }
            });
    }

    isPersonalCodeEmpty () {
        if (this.personalCode !== undefined) {
            this.saveSmartID();
            return false;
        }
        return true;
    }

    isMobileIdReady () {
        if (this.phone !== undefined
            && this.phone.length
            && this.mobileIdPersonalCode !== undefined
            && this.mobileIdPersonalCode.length
            && this.isPhoneNumberValid()
        ) {
            return true;
        }

        return false;
    }

    isPhoneNumberValid () {
        const regex = /^\+37[2|0]/;
        if (regex.test(this.phone)) {
            return true;
        }
        this.mobileIdError = this.$translate.instant('auth.Phone number needs to be entered with country code. For example "+372XXXXXXX"');
        return false;
    }

    saveMobileId () {
        this.mobileIdError = '';
        if (!this.isMobileIdReady()) {
            return;
        }

        this.IdBouncerResource.mobileIdStart({ phoneNumber: this.phone, personalCode: this.mobileIdPersonalCode }).$promise
            .then((data) => {
                this.mobile = true;
                this.mobileSecurityCode = data.verificationCode;
                this.IdBouncerResource.mobileIdFinish({
                    sessionId: data.sessionId,
                    useProfileToken: 1
                }).$promise
                    .then((result) => {
                        if (result.token !== undefined) {
                            this.IdBouncerResource.idProfile({
                                accessToken: result.token,
                                companySlug: this.companySlug
                            }).$promise.then(() => {
                                this.handleSuccess();
                            }).catch(() => {
                                this.mobileIdError = this.$translate.instant('auth.No such account with that personal code was found or authentication was cancelled');
                            });
                        }
                        else {
                            this.mobileIdError = this.$translate.instant('auth.Unable to authenticate via mobile ID');
                        }
                    })
                    .catch(() => {
                        this.mobileIdError = this.$translate.instant('auth.Unable to authenticate via mobile ID');
                    });
            })
            .catch(() => {
                this.mobileIdError = this.$translate.instant('auth.Unable to authenticate via mobile ID');
            });
    }

    saveSmartID () {
        this.smartIdError = '';
        this.IdBouncerResource.smartIdAuthenticate({ personalCode: this.personalCode }).$promise
            .then((data) => {
                this.smartSecurityCode = data.data.verificationCode;
                this.IdBouncerResource.idProfile({
                    countryCode: this.countryCode,
                    personalCode: this.personalCode,
                    companySlug: this.companySlug
                }).$promise.then(() => {
                    this.handleSuccess();
                }).catch(() => {
                    this.smartIdError = this.$translate.instant('auth.No such account with that personal code was found or authentication was cancelled');
                });
            })
            .catch(() => {
                this.smartIdError = this.$translate.instant('auth.Please insert your personal code');
            });
    }

    loginViaSaml () {
        this.samlError = null;
        this.AuthResource.samlLogin({
            companySlug: this.companySlug,
            finalDestinationUrl: encodeURI(this.$location.absUrl())
        }).$promise.then((response) => {
            localStorage.setItem('samlSessionId', response.sessionId);
            this.$window.location.href = response.redirectUrl;
            return;
        }).catch((error) => {
            this.samlError = this.lodash.get(error, 'data[0].message');
        });
    }

    handleSuccess () {
        this.Raven.setUserContext(this.TokenService.getUser());

        this.$state.go(
            this.$state.params.toState, this.lodash.assign(
                this.$state.params.toParams,
                { company: this.TokenService.getCompanySlug() }
            )
        );
    }

    idCardLogin () {
        this.idCardError = '';

        this.IdBouncerResource.idCardChallenge().$promise
            .then(challenge => webeid.authenticate(challenge.nonce, { lang: this.currentLanguage }))
            .then(authToken => this.IdBouncerResource.idCardValidate({}, { authToken }).$promise)
            .then((response) => {
                const accessToken = this.lodash.get(response, 'data.accessToken');
                if (!accessToken) {
                    this.idCardError = this.$translate.instant('auth.idCardError.generic');
                    return null;
                }

                return this.getUser(accessToken).catch(() => {
                    this.idCardError = this.$translate.instant('auth.No such account with that personal code was found or authentication was cancelled');
                });
            })
            .catch((error) => {
                this.idCardError = this.translateIdCardError(error);
                this.Raven.captureException(error);
            });
    }

    get currentLanguage () {
        return (this.$translate.use() || this.$rootScope.company.defaultLanguage).toLowerCase();
    }

    translateIdCardError (error) {
        const messages = {
            ERR_WEBEID_EXTENSION_UNAVAILABLE: 'auth.idCardError.extensionUnavailable',
            ERR_WEBEID_NATIVE_UNAVAILABLE: 'auth.idCardError.nativeUnavailable',
            ERR_WEBEID_USER_CANCELLED: 'auth.idCardError.userCancelled',
            ERR_WEBEID_USER_TIMEOUT: 'auth.idCardError.userTimeout',
            ERR_WEBEID_ACTION_TIMEOUT: 'auth.idCardError.userTimeout'
        };
        const code = this.lodash.get(error, 'code');

        return this.$translate.instant(messages[code] || 'auth.idCardError.generic');
    }

    showAdditionalAuthMethods () {
        return this.authMethods.idCard || this.authMethods.smartId || this.authMethods.mobileId || this.authMethods.sso;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/auth/index.js